import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/Navbar.css";

const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [activeSection, setActiveSection] = useState("home");
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    // Scroll event handler to change navbar background
    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 50;
            setScrolled(isScrolled);
        };

        // Add scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Set initial state
        handleScroll();

        // Cleanup
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Handle navigation and active states
    const handleNavigation = (type, target) => {
        setOpen(false);

        if (type === "section") {
            setActiveSection(target);
            if (location.pathname !== "/") {
                navigate("/");
                setTimeout(() => {
                    document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
                }, 200);
            } else {
                document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
            }
        } else if (type === "page") {
            setActiveSection(target);
        }
    };

    // Intersection Observer only for home page sections
    useEffect(() => {
        if (location.pathname !== "/") return;

        const sections = ["home", "activities", "bookings"];
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            { threshold: 0.6, rootMargin: "-20% 0px -70% 0px" }
        );

        sections.forEach((id) => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [location.pathname]);

    // Update active section based on current route
    useEffect(() => {
        if (location.pathname === "/about") {
            setActiveSection("about");
        } else if (location.pathname === "/contact") {
            setActiveSection("contact");
        }
    }, [location.pathname]);

    return (
        <nav className={`nav ${scrolled ? "scrolled" : ""}`} data-aos="fade-down">
            <div className="nav-logo"> <a className="nav-logo" href="/"> Green Play Turf </a> </div>

            <div className={`nav-links ${open ? "nav-links-open" : ""}`}>
                <button
                    onClick={() => handleNavigation("section", "home")}
                    className={location.pathname === "/" && activeSection === "home" ? "active-link" : ""}
                >
                    Home
                </button>

                <button
                    onClick={() => handleNavigation("section", "activities")}
                    className={location.pathname === "/" && activeSection === "activities" ? "active-link" : ""}
                >
                    Activities
                </button>

                <button
                    onClick={() => handleNavigation("section", "bookings")}
                    className={location.pathname === "/" && activeSection === "bookings" ? "active-link" : ""}
                >
                    Book Now
                </button>

                <Link
                    to="/about"
                    onClick={() => handleNavigation("page", "about")}
                    className={activeSection === "about" ? "active-link" : ""}
                >
                    About us
                </Link>

                <Link
                    to="/contact"
                    onClick={() => handleNavigation("page", "contact")}
                    className={activeSection === "contact" ? "active-link" : ""}
                >
                    Contact
                </Link>
            </div>

            <div className="nav-toggle" onClick={() => setOpen(!open)}>
                <div className={`bar ${open ? "bar1" : ""}`}></div>
                <div className={`bar ${open ? "bar2" : ""}`}></div>
                <div className={`bar ${open ? "bar3" : ""}`}></div>
            </div>
        </nav>
    );
};

export default Navbar;